import Image from 'next/image'
import Link from 'next/link'
import styles from './SpeakerInfo.module.css'
import { ISpeaker } from 'components/Speaker'

const SpeakerInfo: React.FC<ISpeaker> = ({
  photoPng,
  firstName,
  lastName,
  role,
  company,
  instagram,
  bio,
  track,
}) => {
  return (
    <>
      <div className="block sm-none m_x-xs m_t-xs">
        <Link href="/speakers" className="text-action">
          ← back to speakers
        </Link>
      </div>
      <section className="grid t-grid_2">
        <div className={`p_x-xs ${styles.imageSection}`}>
          <div className={styles.image}>
            <Image src={photoPng} alt="" />
          </div>
        </div>
        <article className={`text-m p_x-xs p_y-xs`}>
          <div className={`none ${styles.flex}`}>
            <Link href="/speakers" className="text-action">
              ← back to speakers
            </Link>
          </div>
          <h2 className="m_y-s">
            {firstName} {lastName}
          </h2>
          <div className={`grid text-s ${styles.info}`}>
            {role && (
              <>
                <p>Title:</p>
                <p>{role}</p>
              </>
            )}
            {company && (
              <>
                <p>Company:</p>
                <p>{company}</p>
              </>
            )}
            {track && (
              <>
                <p>Track:</p>
                <p>{track}</p>
              </>
            )}
            {instagram && (
              <>
                <p>Instagram:</p>
                <a
                  target="_blank"
                  className={`link ${styles.link}`}
                  href={`https://www.instagram.com/${instagram}/`}
                >
                  @{instagram}
                </a>
              </>
            )}
          </div>
          {bio && <p className="text-m">{bio}</p>}
        </article>
      </section>
    </>
  )
}

export default SpeakerInfo
